export const NLP_ENABLED = 'nlpEnabled';
export const BOT_STUDIO_ENABLED = 'botStudioEnabled';
export const PROACTIVE_FLOWS_ENABLED = 'proactiveFlowsEnabled';
export const ATTENDANT_TRIAGE_FLOWS_ENABLED = 'attendantTriageFlowsEnabled';
